




















import api from '@/lib/api'
import Vue from 'vue'
export default Vue.extend({
    props: {
        title: String,
        tags: Array,
        category: String,
        thumbnail: String,
        index: Number,
        id: String,
        canDelete: Boolean
    },
    data(){
        return {
            magic: '#'
        }
    },
    mounted(){
        if(this.$props.thumbnail){
            if(!('IntersectionObserver' in window)){
                this.magic = `background: url('${this.$props.thumbnail}') no-repeat center center scroll !important; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;`
            }
            else{

                const observer = new IntersectionObserver((e) => {

                    if(e[0].intersectionRatio <= 0) return;
                    console.log("intersected");
                    
                    this.magic = `background: url('${this.$props.thumbnail}') no-repeat center center scroll !important; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;`
                    observer.unobserve(this.$el);

                })

                observer.observe(this.$el);

            }
        }
    },
    methods: {
        async deleteResource(){
            if(!confirm(`confermi di voler eliminare la risorsa "${this.$props.title}"?`)) return;

            const response = await api.media.resources.deleteResource(this.$props.id);
            if(response.err) return alert("di' a cippi che è successo un casino");

            this.$emit('deleted', this.$props.id);

        }
    }
})
